/**
 * `Sep 23, 02:32 PM` — the compact time a workspace card shows beside an actor.
 * A fixed locale, so two reviewers reading the same mark see the same text.
 *
 * @param {string} iso - Timestamp as the API serialized it.
 */
export const formatShortDateTime = (iso: string): string =>
	new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
